import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";
import {
  addLocationToWatchList,
  removeLocationFromWatchList,
} from "~/lib/server-functions/watchlist";
import { toast } from "sonner";
import {
  addToWatchlistStorage,
  removeFromWatchlistStorage,
} from "~/lib/storage/watchlist-storage";
import { useAuthentication } from "~/lib/better-auth/client";

export const useAddLocationToWatchListMutation = () => {
  const queryClient = useQueryClient();
  const { isAuthenticated } = useAuthentication();
  
  return useMutation({
    mutationFn: async (locationId: number) => {
      if (isAuthenticated) {
        return await addLocationToWatchList({ data: { locationId } });
      } else {
        // For anonymous users, use localStorage
        addToWatchlistStorage(locationId);
        return { success: true };
      }
    },
    onSuccess: (_, variables) => {
      toast.success("Location erfolgreich zur Merkliste hinzugefügt");
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.WATCH_LIST],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.WATCH_LIST, variables],
      });
    },
  });
};

export const useRemoveLocationFromWatchListMutation = () => {
  const queryClient = useQueryClient();
  const { isAuthenticated } = useAuthentication();
  
  return useMutation({
    mutationFn: async (locationId: number) => {
      if (isAuthenticated) {
        return await removeLocationFromWatchList({ data: { locationId } });
      } else {
        // For anonymous users, use localStorage
        removeFromWatchlistStorage(locationId);
        return { success: true };
      }
    },
    onSuccess: (_, variables) => {
      toast.success("Location erfolgreich aus der Merkliste entfernt");
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.WATCH_LIST],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.WATCH_LIST, variables],
      });
    },
  });
};
